import { FC } from 'react';
import { Stack, Skeleton } from '@mui/material';

const HouseholdCompositionLoadingSkeleton: FC = () => {
  return (
    <Stack spacing={2}>
      <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 1 }} />
    </Stack>
  );
};

export default HouseholdCompositionLoadingSkeleton;
